import React, { useState, useEffect } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { Map as LeafletMap, TileLayer, Marker, Popup } from 'react-leaflet'
import { useSelector, useDispatch } from 'react-redux'
import { buscarEndereco } from 'actions/mapaActions'
import './mapa.css'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

async function obterEndereco(latitude, longitude) {
  const response = await axios.get(
    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}6&lon=${longitude}`
  )
  return response.data
}

export const SelecionarLocalMapa = () => {
  const [tituloDialog, setTituloDialog] = useState('')
  const [textoDialog, setTextoDialog] = useState('')
  const [dadosMapa, setDadosMapa] = useState()

  const dispatch = useDispatch()
  const [latitude, setLatitude] = useState(-5.776119)
  const [longitude, setLongitude] = useState(-35.204006)
  const [mensagemPin, setMensagemPin] = useState('Instituto Técnico-Científico de Perícia')
  const mapa = useSelector((state) => state.mapa)
  const zoom = 18
  const [openDialog, setOpenDialog] = React.useState(false)

  const handleClickOpenAlterarEndereco = () => {
    setOpenDialog(true)
  }

  const handleCloseAlterarEndereco = () => {
    setOpenDialog(false)
  }

  const alterarEndereco = () => {
    dispatch(buscarEndereco([dadosMapa]))
    setLatitude(dadosMapa.lat)
    setLongitude(dadosMapa.lon)
    setMensagemPin(dadosMapa.display_name)
    handleCloseAlterarEndereco()
  }

  const alertaAlterarEndereco = (endereco) => {
    setTituloDialog('Deseja alterar o endereço?')
    setTextoDialog(endereco.display_name)
    handleClickOpenAlterarEndereco()
  }
  const pontoSelecionado = (e) => {
    const { lat, lng } = e.latlng
    const resultado = obterEndereco(lat, lng)
    resultado.then((dados) => {
      if (dados) {
        alertaAlterarEndereco(dados)
        setDadosMapa(dados)
      } else
        swal({
          title: 'Good job!',
          text: 'You clicked the button!',
          icon: 'danger',
          button: 'Aww yiss!',
        })
    })
  }
  useEffect(() => {
    if (mapa.dados[0]) {
      setLatitude(mapa.dados[0].lat)
      setLongitude(mapa.dados[0].lon)
      setMensagemPin(mapa.dados[0].display_name)
    }
  }, [mapa])

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <LeafletMap
      center={[latitude, longitude]}
      zoom={zoom}
      maxZoom={100}
      attributionControl
      zoomControl
      doubleClickZoom
      scrollWheelZoom
      dragging
      animate
      easeLinearity={0.35}
      onclick={pontoSelecionado}
    >
      <TileLayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
      <Marker position={[latitude, longitude]}>
        <Popup className="request-popup">
          <div>
            <span>{mensagemPin}</span>
          </div>
        </Popup>
      </Marker>

      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        onClose={handleCloseAlterarEndereco}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{tituloDialog}</DialogTitle>
        <DialogContent>
          <DialogContentText>{textoDialog}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseAlterarEndereco} color="primary">
            Cancelar
          </Button>
          <Button onClick={alterarEndereco} variant="contained" color="primary" autoFocus>
            Aceitar
          </Button>
        </DialogActions>
      </Dialog>
    </LeafletMap>
  )
}
